import React, { useEffect, useRef, useState } from 'react'
import LeftbarUser from '../../Components/LeftbarUser'
import BottomNavUser from '../../Components/BottomNavUser'
import Topbar from '../../Components/Topbar'
import profDefault from '../../Images/def.png'
import defaultCover from '../../Images/coverbg.jpg'
import { useNavigate } from 'react-router-dom'
import BottomNav from '../../Components/BottomNav'
import Form from "react-bootstrap/Form"
import Spinner from 'react-bootstrap/Spinner';
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCamera } from '@fortawesome/free-solid-svg-icons'
import { faInstagram, faTiktok, faYoutube, faLinkedin, faFacebook, faTwitter } from "@fortawesome/free-brands-svg-icons"
import ProgressBar from 'react-bootstrap/ProgressBar';

import { app } from "../../firebase.js"
import { getStorage, ref, uploadBytes, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { doc, updateDoc, getFirestore, getDoc, setDoc, deleteDoc } from "firebase/firestore";
import swal from 'sweetalert';
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";


function UserEditProfile() {
    const [saveButton, setsaveButton] = useState(true);
    const [updateButton, setupdateButton] = useState(false);
    const [now, setNow] = useState(0);
    const [showProgress, setshowProgress] = useState();
    const db = getFirestore(app);
    const [userId, setUserId] = useState()
    const auth = getAuth();
    const navigate = useNavigate();

    const [profileImage, setProfileImage] = useState(profDefault);
    const [coverImage, setcoverImage] = useState(defaultCover)
    const [loggedInName, setloggedInName] = useState();
    const [loggedInemail, setloggedInemail] = useState();

    const [loggedInCategory, setloggedInCategory] = useState();
    const [loggedInPhone, setloggedInPhone] = useState();
    const [loggedInBio, setloggedInBio] = useState();
    const [loggedInLink, setloggedInLink] = useState();
    //
    const nameRef = useRef();
    const phoneRef = useRef();
    const mpesaRef = useRef();
    const categoryRef = useRef();

    useEffect(() => {
        document.title = "Zindua App | Dashboard";

        // Meta description
        let desc = document.querySelector("meta[name='description']");
        if (!desc) {
            desc = document.createElement("meta");
            desc.setAttribute("name", "description");
            document.head.appendChild(desc);
        }
        desc.setAttribute("content", "Zindua App dashboard");

        // Open Graph tags
        const ogTags = [
            { property: "og:title", content: "Zindua App | Dashboard" },
            { property: "og:description", content: "Zindua App Dashboard" },
            { property: "og:type", content: "website" },
            { property: "og:url", content: "https://zindua.app/dashboard" },
            { property: "og:image", content: "https://zindua.app/logo192.png" },
        ];

        ogTags.forEach(({ property, content }) => {
            let tag = document.querySelector(`meta[property='${property}']`);
            if (!tag) {
                tag = document.createElement("meta");
                tag.setAttribute("property", property);
                document.head.appendChild(tag);
            }
            tag.setAttribute("content", content);
        });

        // JSON-LD structured data
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.text = JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Zindua App Influencer Dashboard",
            "url": "https://zindua.app/dashboard",
            "description": "Zindua App influencer dashboard where you can manage your earnings, running ads, subscriptions, and withdraw funds to M-Pesa.",
            "inLanguage": "en",
            "breadcrumb": {
                "@type": "BreadcrumbList",
                "itemListElement": [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": "https://zindua.app/"
                    },
                    {
                        "@type": "ListItem",
                        "position": 2,
                        "name": "Dashboard",
                        "item": "https://zindua.app/dashboard"
                    }
                ]
            }
        });
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, []);


    //get the currently signed in user
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                const uid = user.uid;
                setUserId(uid)
                const docRef = doc(db, "users", uid);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    const data = docSnap.data();

                    // basic info
                    setloggedInName(data.userName || "")
                    setloggedInemail(data.email || "")

                    setloggedInCategory(data.category || "");
                    setloggedInPhone(data.mpesaNumber || "");
                    setloggedInBio(data.about || "");
                    setloggedInLink(data.linkSocial || "");


                    // images
                    setProfileImage(data.profileImage || profDefault)
                    setcoverImage(data.coverImage || defaultCover)

                } else {
                    console.log("No such document!");
                }
            } else {
                navigate("/login");
            }
        });

        return () => unsubscribe();
    }, [navigate, auth]);

    //updating profile image

    function handleProfileChange(e) {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0]
            setProfileImage(URL.createObjectURL(file))

            const storage = getStorage();
            const storageRef = ref(storage, `profiles/${file.name}`);
            const uploadTask = uploadBytesResumable(storageRef, file);

            setshowProgress(true)

            uploadTask.on('state_changed',
                (snapshot) => {

                    //update progress
                    const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
                    setNow(progress)
                },
                (error) => {
                    // Handle unsuccessful uploads
                },
                () => {
                    getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {

                        const userRef = doc(db, "users", userId);

                        updateDoc(userRef, {
                            profileImage: downloadURL
                        }).then(() => {
                            setshowProgress(false)
                            swal("success", "upload successful", "success");

                        })
                    });
                }
            );
        }

    }

    function handleCoverChange(e) {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0]
            setcoverImage(URL.createObjectURL(file))


            const storage = getStorage();
            const storageRef = ref(storage, `profiles/${file.name}`);
            const uploadTask = uploadBytesResumable(storageRef, file);

            setshowProgress(true)

            uploadTask.on('state_changed',
                (snapshot) => {

                    //update progress
                    const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
                    setNow(progress)
                },
                (error) => {
                    // Handle unsuccessful uploads
                },
                () => {
                    getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {

                        const userRef = doc(db, "users", userId);

                        updateDoc(userRef, {
                            coverImage: downloadURL
                        }).then(() => {
                            setshowProgress(false)
                            swal("success", "upload successful", "success");

                        })


                    });
                }
            );

        }
    }

    function saveChanges() {
        setsaveButton(false)
        setupdateButton(true)

        const nameInput = nameRef.current.value;
        const mpesaInput = mpesaRef.current.value;


        if (!mpesaInput || mpesaInput.trim() === "") {
            setsaveButton(true);
            setupdateButton(false);
            swal("Error", "Phone number cannot be empty", "error");
            return;
        }

        const userRef = doc(db, "users", userId);

        updateDoc(userRef, {
            userName: nameInput,
            mpesaNumber: mpesaInput,
        }).then(() => {
            setsaveButton(true)
            setupdateButton(false)
            swal("success", "updated successful", "success");
        })
    }




    return (
        <div className='mainDashboard'>
            <div className="desktopOnly">
                <LeftbarUser />
            </div>

            <div className='mainContent'>
                <Topbar />

                {showProgress &&
                    <ProgressBar now={now} label={`${now}%`} />
                }

                <section className='topProfile'>

                    <div className='profileCover coverWrapper'>
                        <img src={coverImage} alt="" />

                        <label className='coverOverlay'>
                            <FontAwesomeIcon icon={faCamera} className='overlayIcon' />
                            <input type="file" onChange={handleCoverChange} />
                        </label>
                    </div>

                    <div className='profilePhoto photoWrapper'>
                        <img src={profileImage} alt="" />

                        <label className='photoOverlay'>
                            <FontAwesomeIcon icon={faCamera} className='overlayIcon' />
                            <input type="file" onChange={handleProfileChange} />
                        </label>
                    </div>

                </section>

                <section className='editFormSection'>

                    <Form>

                        <Form.Group className='mb-3'>
                            <Form.Label>Your Name</Form.Label>
                            <Form.Control type='text' defaultValue={loggedInName} placeholder='Enter your name' ref={nameRef} />
                        </Form.Group>


                        <Form.Group className='mb-3'>
                            <Form.Label>Email</Form.Label>
                            <Form.Control type='email' value={loggedInemail} disabled placeholder='Enter your email' />
                        </Form.Group>

                        <Form.Group className='mb-3'>
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Control type='text' placeholder='07XXXXXXXX' ref={mpesaRef} defaultValue={loggedInPhone} />
                        </Form.Group>

                        {saveButton &&
                            <button className='saveBtn' type='button' onClick={saveChanges}>Save Changes</button>
                        }

                        {updateButton &&
                            <Button variant="primary" disabled className='saveBtn'>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                {" "}Updating changes...
                            </Button>
                        }

                    </Form>

                </section>

            </div>

            <div className="mobileOnly">
                <BottomNavUser />
            </div>

        </div>
    )
}

export default UserEditProfile